import { Money } from '@afterpay/types'

interface SubtractMoneyConfig {
  moneys: Money[]
}

const toCents = (amount: string): number => {
  const [whole, fraction = ''] = amount.split('.')
  const twoDigits = (fraction + '00').slice(0, 2)
  const magnitude = Math.abs(parseInt(whole, 10) || 0) * 100 + parseInt(twoDigits, 10)
  return whole.trim().startsWith('-') ? -magnitude : magnitude
}

/**
 * Subtracts every subsequent amount from the first. Unlike negating an amount and passing
 * it through `addMoneys`, this handles fractional and negative amounts correctly.
 *
 * @param {object} SubtractMoneyConfig an object with the Money variables. The first amount is
 * the minuend and every subsequent amount is subtracted from it.
 * @returns {string} the resulting amount, as a string
 */
export const subtractMoneys = ({ moneys }: SubtractMoneyConfig): string => {
  const [first, ...rest] = moneys
  let totalCents = toCents(first.amount)
  for (const { amount } of rest) {
    totalCents -= toCents(amount)
  }

  const sign = totalCents < 0 ? '-' : ''
  const absCents = Math.abs(totalCents)
  const dollars = Math.trunc(absCents / 100)
  const centsPart = (absCents % 100).toString().padStart(2, '0')
  return `${sign}${dollars}.${centsPart}`
}
